<template>
  <icon name="times-circle" class='x-flag__times-circle' :scale='scale'></icon>
</template>

<script>
import 'vue-awesome/icons/times-circle'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    Icon
  },
  props: {
    scale: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style>

.x-flag__times-circle {
  color: red;
}

</style>



// WEBPACK FOOTER //
// XFlag.vue?7f55510c